import { useEffect, useState } from 'react';
import { useTranslation } from 'utils/i18n';

// hooks
import useIsMobile from '../../hooks/useIsMobile';
import LandingPage from '../landingPage';
// components
import Page from '../page';
import RoomTypesExplainer from '../roomTypesExplainer';

const RoomsPage = ({
  roomType,
  roomCategory,
  title,
  headerDescription,
  headerTitle,
}: {
  roomType: string;
  roomCategory: string;
  title: string;
  headerDescription?: string;
  headerTitle: string;
}) => {
  const { t } = useTranslation('common');
  const [backgroundImage, setBackgroundImage] = useState('');
  const isMobileView = useIsMobile();

  useEffect(() => {
    const backgroundImageUrl = (isMobile: boolean) => {
      const viewSuffix = isMobile ? '-mobile' : '';
      return `url('../images/landing/${roomType.replace(
        '_',
        '-'
      )}-room${viewSuffix}.jpeg')`;
    };

    setBackgroundImage(backgroundImageUrl(isMobileView));
  }, [isMobileView, roomType]);

  return (
    <Page title={headerTitle} description={headerDescription}>
      <div
        className="banner room-type-banner"
        style={{
          backgroundImage,
        }}
        data-cy="roomTypeLandingPage"
      >
        <div className="inner">
          <LandingPage
            heading={t(`room_types_landing_page.${roomType}.heading`)}
            subHeading={t(`room_types_landing_page.${roomType}.subHeading`)}
            roomType={title}
            pathname={`/book-${roomType}-rooms`}
            locationPlaceholder={t(
              `room_types_landing_page.${roomType}.location_placeholder`
            )}
          />
        </div>
      </div>
      <RoomTypesExplainer
        heading={t(`room_types_landing_page.${roomType}.explainer.heading`)}
        intro={t(`room_types_landing_page.${roomType}.explainer.intro`)}
        // The pages derive this from i18n text, so narrow it here.
        roomCategory={roomCategory as 'clinical' | 'non-clinical' | 'both'}
        displayExplainerItemText={false}
        wrapImageWithLink
        wrapHeadingWithLink
      />
    </Page>
  );
};

export default RoomsPage;
